module.exports = __webpack_public_path__ + "static/media/fitko.173fa572.png";